// extracted by mini-css-extract-plugin
export var acitonButtons = "_i3-0";
export var additionalIcon = "_i3-f";
export var block = "_i3-1";
export var blockContent = "_i3-7";
export var blockDescription = "_i3-8";
export var blockIcon = "_i3-9";
export var blockTitle = "_i3-6";
export var border = "_i3-a";
export var center = "_i3-l";
export var edge = "_i3-b";
export var edgeLabel = "_i3-c";
export var edgePath = "_i3-d";
export var error = "_i3-e";
export var flowchart = "_i3-g";
export var flowchartContent = "_i3-h";
export var highlighted = "_i3-3";
export var hover = "_i3-4";
export var icon = "_i3-i";
export var left = "_i3-m";
export var navButton = "_i3-j";
export var navButtons = "_i3-k";
export var right = "_i3-n";
export var selected = "_i3-2";
export var small = "_i3-5";